module.exports = __webpack_public_path__ + "img/trabajo_textarea.6b18573f.jpg";